import React from 'react';
import { withTheme } from 'styled-components';
export var InfraestructurasIcon = function InfraestructurasIcon(_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "276px",
    height: "265px",
    viewBox: "0 0 276 265",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", null, "Infraestructuras"), React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("g", {
    id: "Infraestructuras",
    transform: "translate(-46.000000, -2.000000)",
    stroke: theme.colors.primary,
    strokeWidth: "15"
  }, React.createElement("g", {
    id: "Infraestructura",
    transform: "translate(54.000000, 9.000000)"
  }, React.createElement("g", {
    id: "Building-Construction__x2F__Buildings__x2F__building-2"
  }, React.createElement("g", {
    id: "Group_26"
  }, React.createElement("g", {
    id: "building-2"
  }, React.createElement("line", {
    x1: "0.19",
    y1: "250.36",
    x2: "260.19",
    y2: "250.36",
    id: "Shape_183"
  }), React.createElement("polygon", {
    id: "Rectangle-path_14",
    points: "22.8 33.32 237.58 33.32 237.58 250.37 22.8 250.37"
  }), React.createElement("line", {
    x1: "0.19",
    y1: "33.32",
    x2: "260.19",
    y2: "33.32",
    id: "Shape_184"
  }), React.createElement("path", {
    d: "M226.28,33.32 L226.28,11.62 C226.28,5.63 221.22,0.77 214.98,0.77 L45.41,0.77 C39.17,0.77 34.11,5.63 34.11,11.62 L34.11,33.32",
    id: "Shape_185"
  }), React.createElement("path", {
    d: "M113.24,250.36 L113.24,212.38 C113.24,203.39 120.83,196.1 130.2,196.1 C139.56,196.1 147.16,203.39 147.16,212.38 L147.16,250.36",
    id: "Shape_186"
  }), React.createElement("line", {
    x1: "56.72",
    y1: "206.95",
    x2: "90.63",
    y2: "206.95",
    id: "Shape_187"
  }), React.createElement("line", {
    x1: "169.76",
    y1: "206.95",
    x2: "203.67",
    y2: "206.95",
    id: "Shape_188"
  }), React.createElement("line", {
    x1: "56.72",
    y1: "163.54",
    x2: "101.94",
    y2: "163.54",
    id: "Shape_189"
  }), React.createElement("line", {
    x1: "158.46",
    y1: "163.54",
    x2: "203.68",
    y2: "163.54",
    id: "Shape_190"
  }), React.createElement("line", {
    x1: "56.72",
    y1: "120.13",
    x2: "101.94",
    y2: "120.13",
    id: "Shape_191"
  }), React.createElement("line", {
    x1: "158.46",
    y1: "120.13",
    x2: "203.68",
    y2: "120.13",
    id: "Shape_192"
  }), React.createElement("line", {
    x1: "56.72",
    y1: "76.73",
    x2: "101.94",
    y2: "76.73",
    id: "Shape_193"
  }), React.createElement("line", {
    x1: "158.46",
    y1: "76.73",
    x2: "203.68",
    y2: "76.73",
    id: "Shape_194"
  }))))))));
};
export default withTheme(InfraestructurasIcon);